import React, { Fragment, useEffect } from 'react';
import ReactDOM from 'react-dom';
import './index.scss';

import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { ScrollContext } from 'react-router-scroll-4';
import * as serviceWorker from './serviceWorker';
import Router from "./router/index";
import { message, notification } from 'antd';

//css
import "./assets/css/comman1.css";
import "./assets/css/comman2.css";
import "./assets/css/comman.css";
import "./assets/css/toast.css";

// ** Import custom components for redux**
import { Provider } from 'react-redux';
import store from './store/index';
import App from "./components/app";

// Import custom Components 
import Default from './components/dashboard/defaultCompo/default';
import Login from './components/Login/Login';
import ToastContainer from './components/ToastContainer';
import { toast } from './utils/toastManager';

// Mock/override antd's message and notification systems globally
const wrapNotification = (type) => (config) => {
    toast.show(config.message || "Alert", config.description || "", type);
};

notification.success = wrapNotification('success');
notification.error = wrapNotification('error');
notification.warning = wrapNotification('warning');
notification.info = wrapNotification('info');
notification.open = (config) => {
    toast.show(config.message || "Alert", config.description || "", config.type || 'info');
};

message.success = (msg) => toast.success('Success', typeof msg === 'string' ? msg : '');
message.error = (msg) => toast.error('Error', typeof msg === 'string' ? msg : '');
message.warning = (msg) => toast.warning('Warning', typeof msg === 'string' ? msg : '');
message.info = (msg) => toast.info('Info', typeof msg === 'string' ? msg : '');

if (process.env.NODE_ENV === "development") {
    const script = document.createElement("script");
    script.src = "https://unpkg.com/react-grab/dist/index.global.js";
    script.crossOrigin = "anonymous";
    script.defer = true;
    document.head.appendChild(script);
}

//firebase Auth
function Root() {
    useEffect(() => {
        const layout = localStorage.getItem('layout_version')
        document.body.classList.add(layout);
    }, []);
    return (
        <div className="App">
            <ToastContainer />
            <Provider store={store}>
                <BrowserRouter basename={'/'}>
                    <ScrollContext>
                        <Router />
                    </ScrollContext>
                </BrowserRouter>
            </Provider>
        </div>
    );
}

ReactDOM.render(<Root />, document.getElementById('root'));

serviceWorker.unregister();